"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonIconPosition = exports.ButtonSize = exports.ButtonColor = exports.ButtonVariant = void 0;
var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["PRIMARY"] = "primary";
    ButtonVariant["SECONDARY"] = "secondary";
    ButtonVariant["TERTIARY"] = "tertiary";
    ButtonVariant["LINK"] = "link";
})(ButtonVariant || (exports.ButtonVariant = ButtonVariant = {}));
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["GREEN"] = "green";
    ButtonColor["RED"] = "red";
})(ButtonColor || (exports.ButtonColor = ButtonColor = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["LARGE"] = "large";
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["SMALL"] = "small";
    ButtonSize["X_SMALL"] = "xSmall";
    ButtonSize["XX_SMALL"] = "xxSmall";
})(ButtonSize || (exports.ButtonSize = ButtonSize = {}));
var ButtonIconPosition;
(function (ButtonIconPosition) {
    ButtonIconPosition["START"] = "left";
    ButtonIconPosition["END"] = "right";
})(ButtonIconPosition || (exports.ButtonIconPosition = ButtonIconPosition = {}));
